import { useEffect, useState } from 'react';

/** Below this width (antd `sm`) tables become cards (ANS-57). */
export const PHONE_MAX_WIDTH = 576;

const isPhoneWidth = (): boolean =>
  typeof window !== 'undefined' && window.innerWidth < PHONE_MAX_WIDTH;

/** True on phones (< 576 px wide); follows window resizes and rotation. */
export const useIsPhone = (): boolean => {
  const [isPhone, setIsPhone] = useState<boolean>(isPhoneWidth);

  useEffect(() => {
    const onResize = () => setIsPhone(isPhoneWidth());
    onResize();
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return isPhone;
};
